import React from "react";
import { Typography, Icon, CircularLoader } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import "./../../scss/admin/components/_integrationsdashboard.scss";
import LineContentLoader from "../../components/ContentLoader/LineContentLoader";
// import  { Modal }   from 'react-bootstrap';

const SelectedBackgroundDiv = styled.div`
  background: ${(props) => props.selected && props.theme.palette.light.c300};
  border-radius: 4px;
`;

const Subcategories = ({
  subcategories,
  templates,
  selectedSubcategory,
  setSelectedSubcategory,
  templatesLoading,
}) => {
  return subcategories?.map((item, i) => {
    const isSelected = item?.id == selectedSubcategory;
    return (
      <SelectedBackgroundDiv
        component="div"
        key={i}
        className={`p-8 mt-8 d-flex flex-row 
          justify-content-between align-items-center w-100 cursor-pointer`}
        onClick={() => {
          setSelectedSubcategory(item?.id);
        }}
        selected={isSelected}
      >
        {isSelected ? (
          <Typography.ButtonText color="dark" shade="c300" component="div">
            {item?.name}
            {/* {templatesLoading ? null : <>({templates?.length}) </>} */}
          </Typography.ButtonText>
        ) : (
          <Typography color="dark" shade="c300" component="div">
            {item?.name}
          </Typography>
        )}

        {!isSelected && (
          <div className="ml-8">
            <Icon iconName="RightArrow" size={14} />
          </div>
        )}
      </SelectedBackgroundDiv>
    );
  });
};

const Categories = ({
  categories,
  templates,
  categoriesLoading,
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  templatesLoading,
}) => {
  return (
    <>
      {categoriesLoading ? (
        <div>
          <LineContentLoader Rows={5} ColumnPerRow={1} />
        </div>
      ) : (
        Object.entries(categories)?.map((item, i) => {
          const isSelected = item[0] == selectedCategory;
          return (
            <>
              <SelectedBackgroundDiv
                component="div"
                key={i}
                className={`p-8 mt-8 d-flex flex-row 
          justify-content-between align-items-center w-100 cursor-pointer`}
                onClick={() => {
                  setSelectedSubcategory(null);
                  setSelectedCategory(item[0]);
                }}
                selected={isSelected && !selectedSubcategory}
              >
                {isSelected ? (
                  <>
                    <Typography.ButtonText
                      color="dark"
                      shade="c300"
                      component="div"
                    >
                      {item[1]?.name}{" "}
                      {/* {selectedSubcategory || templatesLoading ? null : (
                        <>({templates?.length}) </>
                      )} */}
                    </Typography.ButtonText>
                  </>
                ) : (
                  <Typography color="dark" shade="c300" component="div">
                    {item[1]?.name}
                  </Typography>
                )}

                <div className="ml-8">
                  {!isSelected && <Icon iconName={"RightArrow"} size={14} />}
                </div>
              </SelectedBackgroundDiv>
              {isSelected ? (
                <div className="ml-8">
                  <Subcategories
                    subcategories={item[1]?.subcategories}
                    templates={templates}
                    selectedSubcategory={selectedSubcategory}
                    setSelectedSubcategory={setSelectedSubcategory}
                    templatesLoading={templatesLoading}
                  />
                </div>
              ) : null}
            </>
          );
        })
      )}
    </>
  );
};
export default Categories;
